module.exports = __webpack_public_path__ + "img/login-background.b2730584.jpeg";